import React, { useEffect, useState, useContext } from "react";
import InputForm from "../../Components/InputForm/InputForm";
import SelectForm from "../../Components/SelectForm/SelectForm";
import "react-datepicker/dist/react-datepicker.css";
import { Box, TextField, Typography } from "@mui/material";
// import Modal from "@mui/material/Modal";
import { Modal } from "react-bootstrap";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
// import { useNavigate, useLocation } from "react-router-dom";
import { APICall } from "../../Helpers/API/APICalls";
import {
  getCapacityAllocationGridData,
  GetDropDownList,
  getCapacityAllocationById,
  insertUpdateCapacityAllocation,
  getCapacityAllocationDataByEngagement,
  getAllocatedResourcePerMonthApiCall,
  getAllocatedMandaysPerMonthApiCall,
  getTotalAllocatedMandaysApiCall,
  getTotalResourceAllocationApiCall,
  deleteResourceAllocated,
  getResourcePlannedLeave,
  getResourceWorkingDays,
  getTotalAvailableMandays,
  getWorkPolicyWorkdayList,
  InsertUpdateTask,
  getCAID,
  getTaskID,
  getRequirements,
} from "../../Helpers/API/APIEndPoints";
import { enagagementTypeOptions } from "../../Common/CommonJson";
import DynamicGrid from "../../Components/DynamicGrid/DynamicGrid";
import notify from "../../Helpers/ToastNotification";
import moment from "moment";
import uuid from "react-uuid";
import { Button } from "react-bootstrap";
import { getContext, LoaderContext } from "../../Helpers/Context/Context";
import { TaskStatus } from "../../Common/CommonJson";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "antd";
import { APICalls } from "../../Helpers/API/APICalls2";

const CapacityAllocation = (props: any) => {
  let navigate = useNavigate();
  // let location = useLocation();
  const [engagement, setEngagement] = useState<any>({});
  const [engagementOptions, setEngagementOptions] = useState<any>([]);
  const [resourceAllocatedOptions, setResourceAllocatedOptions] = useState<any>(
    []
  );
  const [date, setDate] = useState(moment().startOf("month").toDate());
  // const [
  //   engagementLeadsManagersOptions,
  //   setEngagementLeadsManagersOptions,
  // ] = useState<any>([]);
  const [capacityAllocationGridData, setCapacityAllocationGridData] =
    useState<any>([]);
  const [typeofEngagement, setTypeofEngagement] = useState<any>("");
  const [poResourcesPerMonth, setPoResourcesPerMonth] = useState("");
  const [budgetResourcesPerMonth, setBudgetResourcesPerMonth] = useState("");
  const [allocatedResourcesPerMonth, setAllocatedResourcesPerMonth] =
    useState("");
  const [poMandaysPerMonth, setPoMandaysPerMonth] = useState("");
  const [budgetMandaysPerMonth, setBudgetMandaysPerMonth] = useState("");
  const [allocatedMandaysPerMonth, setAllocatedMandaysPerMonth] = useState("");
  const [poMandays, setPoMandays] = useState("");
  const [budgetMandays, setBudgetMandays] = useState("");
  const [balanceMandays, setBalanceMandays] = useState("");
  const [spentMandays, setSpentMandays] = useState("");
  const [poCompletionDate, setPoCompletionDate] = useState<Date | null>(null);
  const [plannedCompletionDate, setPlannedCompletionDate] =
    useState<Date | null>(null);
  const [resourceAllocated, setResourceAllocated] = useState<any>({});
  // const [engagementLeadsManagers, setEngagementLeadsManagers] = useState<any>({});
  const [isEngagementLead, setIsEngagementLead] = useState(false);
  const [autoTimeSheet, setAutoTimeSheet] = useState(false);
  const [fractionAllocated, setFractionAllocated] = useState<any>("");
  const [totalResourceAllocation, setTotalResourceAllocation] =
    useState<any>("");
  const [mandaysAllocated, setMandaysAllocated] = useState<any>();
  const [totalMandaysAllocated, setTotalMandaysAllocated] = useState<any>("");
  const [pageSize, setPageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [page, setPage] = useState(0);
  const [sortColumn, setSortColumn] = useState("CreatedDate");
  const [sortDirection, setSortDirection] = useState("desc");
  const [searchText, setSearchText] = useState("");
  const [count, setCount] = useState(0);
  const [formError, setFormError] = useState({});
  const context = getContext();
  const [submitId, setSubmitId] = useState(0);
  const [taskid, settaskid] = useState(0);
  let formErrorObj = {};
  const now = new Date();
  const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
  const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
  const [toDate, setToDate] = useState(
    moment().endOf("month").format("YYYY-MM-DD")
  );
  const [fromDate, setFromDate] = useState(
    moment().startOf("month").format("YYYY-MM-DD")
  );
  const [enagagementTypeOptionsArr, setEnagagementTypeOptionsArr] = useState(
    enagagementTypeOptions
  );
  const [showAlert, setShowAlert] = useState(false);
  const [open, setOpen] = useState(false);
  const [capacityAllocationId, setCapacityAllocationId] = useState(0);
  const [resourceLeave, setResourceLeave] = useState<any>("");
  const [resourceWorkingDays, setResourceWorkingDays] = useState("");
  const [totalAvailableMandays, setTotalAvailableMandays] = useState<any>("");
  const [isChargable, setisChargable] = useState<any>(true);
  const [isActive, setIsActive] = useState(false);
  // const [plannedHours, setPlannedHours] =  useState<any>("");
  const [plannedHours, setPlannedHours] = useState<any>(0);
  // const [month, setMonth] = useState(
  //   moment().startOf("month").toDate().getMonth()
  // );
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [disabled, setDisabled] = useState(false); // added by mahesh
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const handleOpen = (id) => {
    setCapacityAllocationId(id);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  // Added custom color for tooltip
  const customColors = ["#2755f3", "#e74c3c"];

  const capacityAllocationGridDataColumns = [
    {
      name: "id",
      label: "Id",
      options: {
        display: false,
      },
    },
    {
      name: "employeeName",
      label: "Resource Allocated",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "fromDate",
      label: "From Date",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
        customBodyRender: (value, tableMeta) => {
          if (value) {
            return moment(value).format(moment.HTML5_FMT.DATE);
          } else {
            return "";
          }
        },
      },
    },
    {
      name: "toDate",
      label: "To Date",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
        customBodyRender: (value, tableMeta) => {
          if (value) {
            return moment(value).format(moment.HTML5_FMT.DATE);
          } else {
            return "";
          }
        },
      },
    },
    {
      name: "isEngagementLead",
      label: "Is Engagement Lead",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          if (value) {
            return <i className="fas fa-check"></i>;
          } else {
            return <i className="fas fa-times"></i>;
          }
        },
      },
    },
    {
      name: "mandays",
      label: "Mandays",
      options: {
        display:
          props.type === "PROJECT" ||
            props.type === "AMC" ||
            props.type === "T&M"
            ? true
            : false,
        filter: false,
        sort: true,
        sortDescFirst: true,
        setCellProps: () => ({
          align: "right",
        }),
        setCellHeaderProps: () => ({
          style: { display: "flex", justifyContent: "right" },
        }),
      },
    },
    // {
    //   name: "fractionAllocated",
    //   label: "Fraction",
    //   options: {
    //     display: props.type === "T&M" ? true : false,
    //     filter: false,
    //     sort: true,
    //     sortDescFirst: true,
    //   },
    // },
    // {
    //   name: "isActive",
    //   label: "Active",
    //   options: {
    //     filter: false,
    //     sort: false,
    //     customBodyRender: (value, tableMeta) => {
    //       if (value) {
    //         return <i className="fas fa-check"></i>;
    //       } else {
    //         return <i className="fas fa-times"></i>;
    //       }
    //     },
    //   },
    // },
    {
      name: "",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          let id = tableMeta.tableData[tableMeta.rowIndex].id;
          return (
            <>
              {/* <a
                onClick={ (e) => {
                  e.preventDefault(); 
                  // navigate("edit", { state: id });
                   getCapacityAllocationByIdApiCall(id)

                }}> */}
              <Tooltip title="Edit" color={customColors[0]}>
                <a
                  onClick={() => getCapacityAllocationByIdApiCall(id)}
                  className="action_icon"
                >
                  <i className="fa fa-pencil" aria-hidden="true"></i>
                </a>
              </Tooltip>
              <Tooltip title="Delete" color={customColors[1]}>
                <a onClick={() => handleOpen(id)} className="action_icon">
                  {/* <DeleteForeverIcon /> */}
                  <i className="fa fa-trash" aria-hidden="true"></i>
                </a>
              </Tooltip>
            </>
          );
        },
      },
    },
  ];

  const getResourceWorkingDaysApi = async (id = 0) => {
    let obj = { Eid: id, FromDate: fromDate, ToDate: toDate };
    const { data } = await APICall(getResourceWorkingDays, "POST", obj);

    if (data !== null) {
      setResourceWorkingDays(data);
    } else {
      setResourceWorkingDays("");
    }
  };

  const selectOnChange = async (event: any, apiFieldName: any) => {
    if (apiFieldName === "engagement") {
      setEngagement(event);
      if (event && Object.keys(event).length > 0) {
        await getCapacityEngagementByIdApiCall(event.engagementId);
        await getCapacityAllocationGridDataApiCall(
          "engagement",
          event.engagementId
        );
        await getAllocatedResourcePerMonth("engagement", event.engagementId);
        await getAllocatedMandaysPerMonth("engagement", event.engagementId);
      } else if (!event || Object.keys(event).length === 0) {
        setFormError((preState) => ({
          ...preState,
          ["engagement_isEmpty"]: "Engagement can not be empty",
        }));
        formErrorObj["engagement_isEmpty"] = "Engagement can not be empty";
      }
    }

    if (apiFieldName === "Year&Month") {
      setPage(0);
      setStart(0);
      setDate(event);

      const startOfMonth = moment(event)
        .clone()
        .startOf("month")
        .format("YYYY-MM-DD");

      const endOfMonth = moment(event)
        .clone()
        .endOf("month")
        .format("YYYY-MM-DD");

      setFromDate(startOfMonth);
      setToDate(endOfMonth);
      //await getCapacityAllocationGridDataApiCall("", "");
    }

    if (apiFieldName === "typeofEngagement") {
      setEngagement({});
      setTypeofEngagement(event);
      if (event && Object.keys(event).length > 0) {
        await capacityEngagementApiCall(event.value);
      } else if (!event || Object.keys(event).length === 0) {
        setFormError((preState) => ({
          ...preState,
          ["typeofEngagement_isEmpty"]: "Engagement type can not be empty",
        }));
        formErrorObj["typeofEngagement_isEmpty"] =
          "Engagement type can not be empty";
      }
    }
    // if (apiFieldName === "engagementLeadsManagers") {
    //   setEngagementLeadsManagers(event);
    //   if (event && Object.keys(event).length > 0) {
    //   } else if (!event || Object.keys(event).length === 0) {
    //     setFormError((preState) => ({
    //       ...preState,
    //       ["engagementLeadsManagers_isEmpty"]: "Engagement Leads/Managers can not be empty",
    //     }));
    //     formErrorObj["engagementLeadsManagers_isEmpty"] = "Engagement Leads/Managers can not be empty"
    //   }
    // }
    if (apiFieldName === "resourceAllocated") {
      setResourceAllocated(event);
      await getTotalAllocatedMandays("resourceAllocated", event.value);
      await getTotalResourceAllocation("resourceAllocated", event.value);
      await getResourceLeaves(event.value);
      await getAllAvailableMandays(event.value);
      await getResourceWorkingDaysApi(event.value);
      if (event && Object.keys(event).length > 0) {
      } else if (!event || Object.keys(event).length === 0) {
        setFormError((preState) => ({
          ...preState,
          ["resourceAllocated_isEmpty"]: "Resource allocated can not be empty",
        }));
        formErrorObj["resourceAllocated_isEmpty"] =
          "Resource allocated can not be empty";
      }
    }
  };

  const handleTextEvent = async (event: any, apiFieldName: any) => {
    if (apiFieldName === "poResourcesPerMonth") {
      setPoResourcesPerMonth(event.target.value); //disabled
    }
    if (apiFieldName === "budgetResourcesPerMonth") {
      setBudgetResourcesPerMonth(event.target.value); //disabled
    }
    if (apiFieldName === "allocatedResourcesPerMonth") {
      setAllocatedResourcesPerMonth(event.target.value); //disabled
    }
    if (apiFieldName === "poMandaysPerMonth") {
      setPoMandaysPerMonth(event.target.value); //disabled
    }
    if (apiFieldName === "budgetMandaysPerMonth") {
      setBudgetMandaysPerMonth(event.target.value); //disabled
    }
    if (apiFieldName === "allocatedMandaysPerMonth") {
      setAllocatedMandaysPerMonth(event.target.value); //disabled
    }
    if (apiFieldName === "poMandays") {
      setPoMandays(event.target.value); //disabled
    }
    if (apiFieldName === "budgetMandays") {
      setBudgetMandays(event.target.value); //disabled
    }
    if (apiFieldName === "spentMandays") {
      setSpentMandays(event.target.value); //disabled
    }
    if (apiFieldName === "balancedMandays") {
      setBalanceMandays(event.target.value); //disabled
    }
    if (apiFieldName === "poCompletionDate") {
      setPoCompletionDate(event); //disabled
    }
    if (apiFieldName === "plannedCompletionDate") {
      setPlannedCompletionDate(event); //disabled
    }
    if (apiFieldName === "fromDate") {
      if (event) {
        await getCapacityAllocationGridDataApiCall("fromDate", new Date(event));
        await getAllocatedResourcePerMonth("fromDate", new Date(event));
        await getAllocatedMandaysPerMonth("fromDate", new Date(event));
        await getTotalAllocatedMandays("fromDate", new Date(event));
        await getTotalResourceAllocation("fromDate", new Date(event));
        setFromDate(event);
        setFormError((preState) => ({
          ...preState,
          ["fromDate_isEmpty"]: undefined,
        }));
        formErrorObj["fromDate_isEmpty"] = undefined;
      } else {
        await getCapacityAllocationGridDataApiCall(
          "fromDate",
          new Date(fromDate)
        );
        await getAllocatedResourcePerMonth("fromDate", new Date(fromDate));
        await getAllocatedMandaysPerMonth("fromDate", new Date(fromDate));
        await getTotalAllocatedMandays("fromDate", new Date(fromDate));
        await getTotalResourceAllocation("fromDate", new Date(fromDate));
        setFromDate(fromDate);
        setFormError((preState) => ({
          ...preState,
          ["fromDate_isEmpty"]: "From date can not be empty",
        }));
        formErrorObj["fromDate_isEmpty"] = "From date can not be empty";
      }
    }
    if (apiFieldName === "toDate") {
      if (event) {
        await getCapacityAllocationGridDataApiCall("toDate", new Date(event));
        await getAllocatedResourcePerMonth("toDate", new Date(event));
        await getAllocatedMandaysPerMonth("toDate", new Date(event));
        await getTotalAllocatedMandays("toDate", new Date(event));
        await getTotalResourceAllocation("toDate", new Date(event));
        setToDate(event);
        setFormError((preState) => ({
          ...preState,
          ["toDate_isEmpty"]: undefined,
        }));
        formErrorObj["toDate_isEmpty"] = undefined;
      } else {
        await getCapacityAllocationGridDataApiCall("toDate", new Date(toDate));
        await getAllocatedResourcePerMonth("toDate", new Date(toDate));
        await getAllocatedMandaysPerMonth("toDate", new Date(toDate));
        await getTotalAllocatedMandays("toDate", new Date(toDate));
        await getTotalResourceAllocation("toDate", new Date(toDate));
        setToDate(toDate);
        setFormError((preState) => ({
          ...preState,
          ["toDate_isEmpty"]: "To date can not be empty",
        }));
        formErrorObj["toDate_isEmpty"] = "To date can not be empty";
      }
    }

    if (apiFieldName === "Year&Month") {
      setDate(event);

      const startOfMonth = moment(event)
        .clone()
        .startOf("month")
        .format("YYYY-MM-DD");

      const endOfMonth = moment(event)
        .clone()
        .endOf("month")
        .format("YYYY-MM-DD");

      setFromDate(startOfMonth);
      setToDate(endOfMonth);

      await getCapacityAllocationGridDataApiCall("", "");
    }

    if (apiFieldName === "fractionAllocated") {
      setFractionAllocated(event.target.value);
      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.toString().trim() !== ""
      ) {
        setFormError((preState) => ({
          ...preState,
          ["fractionAllocated_isEmpty"]: undefined,
        }));
        formErrorObj["fractionAllocated_isEmpty"] = undefined;
      } else if (
        !event.target.value ||
        event.target.value === "" ||
        event.target.value.toString().trim() === ""
      ) {
        setFormError((preState) => ({
          ...preState,
          ["fractionAllocated_isEmpty"]: "Fraction allocated can not be empty",
        }));
        formErrorObj["fractionAllocated_isEmpty"] =
          "Fraction allocated can not be empty";
      }
    }
    if (apiFieldName === "totalResourceAllocation") {
      setTotalResourceAllocation(event.target.value);
      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.toString().trim() !== ""
      ) {
        setFormError((preState) => ({
          ...preState,
          ["totalResourceAllocation_isEmpty"]: undefined,
        }));
        formErrorObj["totalResourceAllocation_isEmpty"] = undefined;
      } else if (
        !event.target.value ||
        event.target.value === "" ||
        event.target.value.toString().trim() === ""
      ) {
        setFormError((preState) => ({
          ...preState,
          ["totalResourceAllocation_isEmpty"]:
            "Total resource allocation can not be empty",
        }));
        formErrorObj["totalResourceAllocation_isEmpty"] =
          "Total resource allocation can not be empty";
      }
    }
    if (apiFieldName === "mandaysAllocated") {
      setMandaysAllocated(event.target.value);
      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.toString().trim() !== ""
      ) {
        setFormError((preState) => ({
          ...preState,
          ["mandaysAllocated_isEmpty"]: undefined,
        }));
        formErrorObj["mandaysAllocated_isEmpty"] = undefined;
      } else if (
        !event.target.value ||
        event.target.value === "" ||
        event.target.value.toString().trim() === ""
      ) {
        setFormError((preState) => ({
          ...preState,
          ["mandaysAllocated_isEmpty"]: "Mandays allocated can not be empty",
        }));
        formErrorObj["mandaysAllocated_isEmpty"] =
          "Mandays allocated can not be empty";
      }
    }
    if (apiFieldName === "totalMandaysAllocated") {
      setTotalMandaysAllocated(event.target.value);
      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.toString().trim() !== ""
      ) {
        setFormError((preState) => ({
          ...preState,
          ["totalMandaysAllocated_isEmpty"]: undefined,
        }));
        formErrorObj["totalMandaysAllocated_isEmpty"] = undefined;
      } else if (
        !event.target.value ||
        event.target.value === "" ||
        event.target.value.toString().trim() === ""
      ) {
        setFormError((preState) => ({
          ...preState,
          ["totalMandaysAllocated_isEmpty"]:
            "Total mandays allocated can not be empty",
        }));
        formErrorObj["totalMandaysAllocated_isEmpty"] =
          "Total mandays allocated can not be empty";
      }
    }
  };

  const modelClose = (id: any) => {
    if (id === "cancel") {
      setShowAlert(false);
    } else if (id === "ok") {
      submitFunc("submit");
      setShowAlert(false);
    }
  };

  const resetFunc = () => {
    setFormError({});
    if (props.type === "AMC") {
      setCapacityAllocationGridData([]);
      setEngagement({});
      // setTypeofEngagement({});
      // setEngagementLeadsManagers({})
      setPoMandaysPerMonth("");
      setResourceAllocated({});
      setBudgetMandaysPerMonth("");
      setAllocatedMandaysPerMonth("");
      setMandaysAllocated(0);
      setTotalMandaysAllocated("");
      setResourceLeave("");
      setResourceWorkingDays("");
      setIsEngagementLead(false);
      setTotalAvailableMandays("");
      // setFromDate(firstDay);
      // setToDate(lastDay);
    }
    if (props.type === "PROJECT") {
      setCapacityAllocationGridData([]);
      setEngagement({});
      // setTypeofEngagement({});
      // setEngagementLeadsManagers({})
      setPoMandays("");
      setBudgetMandays("");
      setSpentMandays("");
      setBalanceMandays("");
      setPoCompletionDate(null);
      setPlannedCompletionDate(null);
      setIsEngagementLead(false);
      setResourceAllocated({});
      setMandaysAllocated(0);
      setFromDate(moment().startOf("month").format("YYYY-MM-DD"));
      setToDate(moment().endOf("month").format("YYYY-MM-DD"));
      setResourceLeave("");
      setTotalAvailableMandays("");
      setResourceWorkingDays("");
    }
    if (props.type === "T&M") {
      setCapacityAllocationGridData([]);
      setEngagement({});
      // setTypeofEngagement({});
      // setEngagementLeadsManagers({})
      setPoResourcesPerMonth("");
      setBudgetResourcesPerMonth("");
      setAllocatedResourcesPerMonth("");
      setIsEngagementLead(false);
      setAutoTimeSheet(false);
      setTotalResourceAllocation("");
      setTotalMandaysAllocated("");
      setFractionAllocated("");
      setResourceAllocated({});
      setFromDate(moment().startOf("month").format("YYYY-MM-DD"));
      setToDate(moment().endOf("month").format("YYYY-MM-DD"));
      setResourceLeave("");
      setTotalAvailableMandays("");
      setResourceWorkingDays("");
    }
  };

  const submitApiCall = async (submitObj: any) => {
    const { data } = await APICall(
      insertUpdateCapacityAllocation,
      "POST",
      submitObj
    );
    if (data === false) {
      notify(
        1,
        `Resource already allocated for selected engagement between ${moment(
          fromDate
        ).format(moment.HTML5_FMT.DATE)} and ${moment(toDate).format(
          moment.HTML5_FMT.DATE
        )}`
      );
      return;
    } else {
      await CreatePlannedHours();
    }

    if (data && data > 0) {
      await getCapacityAllocationGridDataApiCall(
        "engagement",
        submitObj.engagementId
      ); //sangam
      if (props.type === "AMC") {
        setPoMandaysPerMonth("");
        setResourceAllocated({});
        setBudgetMandaysPerMonth("");
        setAllocatedMandaysPerMonth("");
        setMandaysAllocated("");
        setTotalMandaysAllocated("");
        setResourceLeave("");
        setTotalAvailableMandays("");
        setResourceWorkingDays("");
        setIsEngagementLead(false);
        //setAutoTimeSheet(false);
        setPlannedHours(0);
        // setFromDate(firstDay);
        // setToDate(lastDay);
      }
      if (props.type === "PROJECT") {
        setPoMandays("");
        setBudgetMandays("");
        setSpentMandays("");
        setBalanceMandays("");
        setPoCompletionDate(null);
        setPlannedCompletionDate(null);
        setIsEngagementLead(false);
        // setAutoTimeSheet(false);
        setResourceAllocated({});
        setResourceWorkingDays("");
        setMandaysAllocated("");
        setTotalMandaysAllocated("");
        setResourceLeave("");
        setTotalAvailableMandays("");
        setPlannedHours(0);
        // setEngagement({});
        // setTypeofEngagement({});
        // setCapacityAllocationGridData([]);
        // setFromDate(firstDay);
        // setToDate(lastDay);
      }
      if (props.type === "T&M") {
        setPoMandaysPerMonth("");
        setResourceAllocated({});
        setBudgetMandaysPerMonth("");
        setAllocatedMandaysPerMonth("");
        setMandaysAllocated("");
        setTotalMandaysAllocated("");
        setResourceLeave("");
        setTotalAvailableMandays("");
        setResourceWorkingDays("");
        setIsEngagementLead(false);
        setAutoTimeSheet(false);
        setPlannedHours(0);
      }
      if (
        engagement &&
        engagement.engagementId &&
        firstDay &&
        lastDay &&
        props.type === "AMC"
      ) {
        await getAllocatedMandaysPerMonthEdit(
          engagement.engagementId,
          moment(firstDay).format(moment.HTML5_FMT.DATE),
          moment(lastDay).format(moment.HTML5_FMT.DATE)
        );
      }
      if (
        engagement &&
        engagement.engagementId &&
        firstDay &&
        lastDay &&
        props.type === "T&M"
      ) {
        await getAllocatedResourcesPerMonthEdit(
          engagement.engagementId,
          moment(firstDay).format(moment.HTML5_FMT.DATE),
          moment(lastDay).format(moment.HTML5_FMT.DATE)
        );
      }
      if (
        engagement &&
        engagement.engagementId &&
        firstDay &&
        lastDay &&
        props.type === "PROJECT"
      ) {
        await getAllocatedMandaysPerMonthEdit(
          engagement.engagementId,
          moment(firstDay).format(moment.HTML5_FMT.DATE),
          moment(lastDay).format(moment.HTML5_FMT.DATE)
        );
      }

      await getCapacityEngagementByIdApiCall(engagement.engagementId);
      await getCapacityAllocationGridDataApiCallAfterSubmit(
        engagement.engagementId,
        fromDate,
        toDate
      );
      await onLoadFunCall();

      if (submitId) {
        setSubmitId(0);
        notify(0, "Capacity  Updated successfully");
      } else {
        setSubmitId(0);
        notify(0, "Capacity Allocated successfully");
        setStart(0);
        setPage(0);
      }
    } else {
      if (submitId) {
        notify(1, "Capacity  updation failed");
      } else {
        setSubmitId(0);
        notify(1, "Capacity allocation failed");
      }
    }
  };

  const getCapacityAllocationGridDataApiCallAfterSubmit = async (
    //sangam
    engagementIdAfterSave: any,
    firstDayFromDate: any,
    lastDayFromDate: any
  ) => {
    let post = {};
    if (
      engagementIdAfterSave &&
      engagementIdAfterSave !== 0 &&
      firstDayFromDate &&
      lastDayFromDate
    ) {
      post = {
        EngagementId: engagementIdAfterSave,
        FromDate: moment(new Date(firstDayFromDate)).format(
          moment.HTML5_FMT.DATE
        ),
        ToDate: moment(new Date(lastDayFromDate)).format(moment.HTML5_FMT.DATE),
        selectableRows: "none",
        //passing start , pageSize ,sortColumn,sortOrder --sangam
        start: start,
        pageSize: pageSize,
        sortColumn: sortColumn,
        sortDirection: sortDirection,
        onChangeRowsPerPage: (num) => { },
        onSearchChange: (searchText) => {
          if (searchText !== null) {
            setSearchText(searchText);
          } else {
            setSearchText("");
          }
        },
      };
    }

    const { data } = await APICall(getCapacityAllocationGridData, "POST", post);
    if (data.length) {
      await setCapacityAllocationGridData(data);

      await setCount(data[0].totalCount && data[0].totalCount); //sangam
    }
  };

  const onSubmitValidation = () => {
    formErrorObj = {};
    if (!fromDate) {
      formErrorObj["fromDate_isEmpty"] = "From date can not be empty";
    }
    if (!toDate) {
      formErrorObj["toDate_isEmpty"] = "To date can not be empty";
    }
    if (!engagement || Object.keys(engagement).length === 0) {
      formErrorObj["engagement_isEmpty"] = "Engagement can not be empty";
    }
    if (!typeofEngagement || Object.keys(typeofEngagement).length === 0) {
      formErrorObj["typeofEngagement_isEmpty"] =
        "Engagement type can not be empty";
    }
    // if (!engagementLeadsManagers || Object.keys(engagementLeadsManagers).length === 0) {
    //   formErrorObj["engagementLeadsManagers_isEmpty"] = "Engagement leads/managers can not be empty"
    // }
    if (!resourceAllocated || Object.keys(resourceAllocated).length === 0) {
      formErrorObj["resourceAllocated_isEmpty"] =
        "Resource allocated can not be empty";
    }
    if (props.type === "T&M") {
      //   if (
      //     typeof fractionAllocated === "string" &&
      //     (!fractionAllocated || fractionAllocated.toString().trim() === "")
      //   ) {
      //     formErrorObj["fractionAllocated_isEmpty"] =
      //       "Fraction allocated can not be empty";
      //   } else if (fractionAllocated < 0 || fractionAllocated > 1) {
      //     formErrorObj["fractionAllocated_isEmpty"] =
      //       "Fraction allocated can not be greater than 1";
      //   } else if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(fractionAllocated)) {
      //     formErrorObj["fractionAllocated_isEmpty"] =
      //       "Fraction allocated should have maximum 2 decimals only";
      //   }
      // } else {

      if (
        mandaysAllocated <= 0 &&
        autoTimeSheet == true
        // (typeof mandaysAllocated === "string" &&
        //   (!mandaysAllocated || mandaysAllocated.toString().trim() === "")) ||
        //  (typeof mandaysAllocated === "number" && mandaysAllocated <=  0)
      ) {
        formErrorObj["mandaysAllocated_isEmpty"] =
          "Mandays allocated can not be empty or negative";
      } else if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(mandaysAllocated)) {
        formErrorObj["mandaysAllocated_isEmpty"] =
          "Mandays allocated should have maximum 2 decimals only";
      }
    }

    setFormError(formErrorObj);
  };

  const submitFunc = async (action: any) => {
    showLoader();
    let submitObj: any = {};
    if (action === "submit") {
      setDisabled(true);
      submitObj = {
        engagementId: engagement.engagementId,
        fromDate: moment(fromDate).format(moment.HTML5_FMT.DATE),
        toDate: moment(toDate).format(moment.HTML5_FMT.DATE),
        employeeId: resourceAllocated.value,
        fractionAllocated: Number(fractionAllocated), //fractionAllocated,
        // mandays: Number(mandaysAllocated),
        mandays: mandaysAllocated,
        isActive: true,
        isEngagementLead: isEngagementLead,
        autoTimesheet: autoTimeSheet,
        createdBy: Number(context.EmployeeId),
      };

      if (submitId !== 0) {
        submitObj.Id = submitId;

        //  const data = await APICall (getCAID , "POST", submitId)
      }

      //  const data = await APICall (getCAID , "POST", submitId)
      await onSubmitValidation();
      // await CreatePlannedHours();
      let isEmpty = Object.values(formErrorObj).every(
        (f) => f === "" || f === null || f === undefined
      );
      if (isEmpty === true) {
        setDisabled(false);
        const data = await submitApiCall(submitObj);
      } else {
        setDisabled(false);
      }
    }
    if (action === "reset") {
      resetFunc();
    }
    hideLoader();
  };

  const getCapacityEngagementByIdApiCall = async (engagementId: any) => {
    if (engagementId !== 0 && props.type && props.type !== "") {
      let post = {
        EngagementId: engagementId,
        EngagementType: props.type,
      };
      const { data } = await APICall(
        getCapacityAllocationDataByEngagement,
        "POST",
        post
      );

      if (data && Object.keys(data).length > 0 && props.type === "AMC") {
        setPoMandaysPerMonth(data.pomanDaysPerMonth);
        setBudgetMandaysPerMonth(data.budgetMandaysPerMonth);
      }
      if (data && Object.keys(data).length > 0 && props.type === "T&M") {
        setPoResourcesPerMonth(data.poresourcesPerMonth);
        setBudgetResourcesPerMonth(data.budgetResoucesPerMonth);
      }
      if (data && Object.keys(data).length > 0 && props.type === "PROJECT") {
        setPoMandays(data.pomanDays);
        setBudgetMandays(data.budgetMandays);
        setPoCompletionDate(new Date(data.pocompletionDate));
        setPlannedCompletionDate(new Date(data.plannedCompletionDate));
        setSpentMandays(data.spentMandates);
        setBalanceMandays(data.balanceMandays);
      }
    }
  };

  const getCapacityAllocationGridDataApiCall = async (
    field: any,
    value: any
  ) => {
    let post = {};

    if (field === "engagement" && fromDate && toDate && value) {
      post = {
        EngagementId: value,
        FromDate: moment(fromDate).format(moment.HTML5_FMT.DATE),
        ToDate: moment(toDate).format(moment.HTML5_FMT.DATE),
        //passing start , pageSize ,sortColumn,sortOrder --sangam
        start: start,
        pageSize: pageSize,
        sortColumn: sortColumn,
        sortDirection: sortDirection,
      };
    } else if (
      field === "fromDate" &&
      engagement &&
      engagement.engagementId &&
      engagement.engagementId !== 0 &&
      toDate &&
      value
    ) {
      post = {
        EngagementId: engagement.engagementId,
        FromDate: moment(new Date(value)).format(moment.HTML5_FMT.DATE),
        ToDate: moment(toDate).format(moment.HTML5_FMT.DATE),
        //passing start , pageSize ,sortColumn,sortOrder --sangam
        start: start,
        pageSize: pageSize,
        sortColumn: sortColumn,
        sortDirection: sortDirection,
      };
    } else if (
      field === "toDate" &&
      engagement &&
      engagement.engagementId &&
      engagement.engagementId !== 0 &&
      fromDate &&
      value
    ) {
      post = {
        EngagementId: engagement.engagementId,
        FromDate: moment(fromDate).format(moment.HTML5_FMT.DATE),
        ToDate: moment(new Date(value)).format(moment.HTML5_FMT.DATE),
        //passing start , pageSize ,sortColumn,sortOrder --sangam
        start: start,
        pageSize: pageSize,
        sortColumn: sortColumn,
        sortDirection: sortDirection,
      };
    } else if (
      field === "" &&
      engagement &&
      engagement.engagementId &&
      engagement.engagementId !== 0 &&
      fromDate &&
      toDate
    ) {
      post = {
        EngagementId: engagement.engagementId,
        FromDate: moment(fromDate).format(moment.HTML5_FMT.DATE),
        ToDate: moment(toDate).format(moment.HTML5_FMT.DATE),
        //passing start , pageSize ,sortColumn,sortOrder --sangam
        start: start,
        pageSize: pageSize,
        sortColumn: sortColumn,
        sortDirection: sortDirection,
      };
    } else if (engagement.engagementId == undefined && fromDate && toDate) {
      post = {
        EngagementId: 0,
        FromDate: moment(fromDate).format(moment.HTML5_FMT.DATE),
        ToDate: moment(toDate).format(moment.HTML5_FMT.DATE),
        //passing start , pageSize ,sortColumn,sortOrder --sangam
        start: start,
        pageSize: pageSize,
        sortColumn: sortColumn,
        sortDirection: sortDirection,
      };
    }

    const { data } = await APICall(getCapacityAllocationGridData, "POST", post);

    if (data.length) {
      await setCapacityAllocationGridData(data);
      await setCount(data[0].totalCount && data[0].totalCount); // sangam
    } else {
      //sangam
      setStart(0);
      setCount(0);
      setPage(0);
      await setCapacityAllocationGridData([]);
    }

    // if (engagementId !== 0) {
    //   let requestParams = {
    //     EngagementId: engagementId,

    //     // start: start,
    //     // pageSize: pageSize,
    //     // sortColumn: sortColumn,
    //     // sortDirection: sortDirection,
    //     // searchText: searchText,
    //   };
    //   const { data } = await APICall(
    //     getCapacityAllocationGridData,
    //     "POST",
    //     requestParams
    //   );
    //   setCapacityAllocationGridData(data);
    //   // setCount(data.count);
    // }
  };

  const getAllocatedResourcesPerMonthEdit = async (
    engagementIdEdit: any,
    fromDateEdit: any,
    toDateEdit: any
  ) => {
    let post = {};
    if (engagementIdEdit !== 0 && fromDateEdit && toDateEdit) {
      post = {
        EngagementId: engagementIdEdit,
        FromDate: moment(fromDateEdit).format(moment.HTML5_FMT.DATE),
        ToDate: moment(toDateEdit).format(moment.HTML5_FMT.DATE),
      };
    }
    const { data } = await APICall(
      getAllocatedResourcePerMonthApiCall,
      "POST",
      post
    );
    if (data) {
      setAllocatedResourcesPerMonth(data.allocatedResourcePerMonth);
    }
  };

  const getAllocatedMandaysPerMonthEdit = async (
    engagementIdEdit: any,
    fromDateEdit: any,
    toDateEdit: any
  ) => {
    let post = {};
    if (engagementIdEdit !== 0 && fromDateEdit && toDateEdit) {
      post = {
        EngagementId: engagementIdEdit,
        FromDate: moment(fromDateEdit).format(moment.HTML5_FMT.DATE),
        ToDate: moment(toDateEdit).format(moment.HTML5_FMT.DATE),
      };
    }
    const { data } = await APICall(
      getAllocatedMandaysPerMonthApiCall,
      "POST",
      post
    );
    if (data && data.allocatedMandaysPerMonth) {
      setAllocatedMandaysPerMonth(data.allocatedMandaysPerMonth || 0);
    }
  };

  const getTotalMandaysAllocatedEdit = async (
    resourceAllocatedEdit: any,
    fromDateEdit: any,
    toDateEdit: any,
    allocatedMandaysEdit: any
  ) => {
    let post = {};
    if (
      resourceAllocatedEdit &&
      resourceAllocatedEdit !== 0 &&
      fromDateEdit &&
      toDateEdit
    ) {
      post = {
        EmployeeId: resourceAllocatedEdit,
        FromDate: moment(fromDateEdit).format(moment.HTML5_FMT.DATE),
        ToDate: moment(toDateEdit).format(moment.HTML5_FMT.DATE),
      };
    }
    const { data } = await APICall(
      getTotalAllocatedMandaysApiCall,
      "POST",
      post
    );
    if (data && data.totalAllocatedMandays) {
      if (
        data.totalAllocatedMandays &&
        data.totalAllocatedMandays !== "" &&
        Number(data.totalAllocatedMandays) >= 0 &&
        allocatedMandaysEdit &&
        allocatedMandaysEdit !== "" &&
        Number(allocatedMandaysEdit) >= 0
      ) {
        data.totalAllocatedMandays =
          Number(data.totalAllocatedMandays) - Number(allocatedMandaysEdit);
      }
      setTotalMandaysAllocated(data.totalAllocatedMandays);
    }
  };

  const getTotalResourceAllocationEdit = async (
    resourceAllocatedEdit: any,
    fromDateEdit: any,
    toDateEdit: any,
    allocatedFractionEdit: any
  ) => {
    let post = {};
    if (
      resourceAllocatedEdit &&
      resourceAllocatedEdit !== 0 &&
      fromDateEdit &&
      toDateEdit
    ) {
      post = {
        EmployeeId: resourceAllocatedEdit,
        FromDate: moment(fromDateEdit).format(moment.HTML5_FMT.DATE),
        ToDate: moment(toDateEdit).format(moment.HTML5_FMT.DATE),
      };
    }
    const { data } = await APICall(
      getTotalResourceAllocationApiCall,
      "POST",
      post
    );
    if (data && data.totalResourceAllocation) {
      if (
        data.totalResourceAllocation &&
        data.totalResourceAllocation !== "" &&
        Number(data.totalResourceAllocation) >= 0 &&
        allocatedFractionEdit &&
        allocatedFractionEdit !== "" &&
        Number(allocatedFractionEdit) >= 0
      ) {
        data.totalResourceAllocation =
          Number(data.totalResourceAllocation) - Number(allocatedFractionEdit);
      }
      setTotalResourceAllocation(data.totalResourceAllocation);
    }
  };

  const getCapacityAllocationByIdApiCall = async (Id: any) => {
    setFormError({});
    formErrorObj = {};
    if (Id !== 0) {
      let post = {
        id: Id,
      };
      const { data } = await APICall(getCapacityAllocationById, "POST", post);

      if (data && Object.keys(data).length > 0) {
        setSubmitId(data.id);
        setFromDate(data.fromDate);
        setToDate(data.toDate);
        setIsEngagementLead(data.isEngagementLead);
        setAutoTimeSheet(data.autoTimesheet);
        setIsActive(data.isActive);
        await enagagementTypeOptions.map((ele) => {
          if (ele.value === Number(data.engagementType)) {
            setTypeofEngagement(ele);
          }
        });
        await engagementOptions.map(async (ele: any) => {
          if (ele.engagementId === data.engagementId) {
            setEngagement(ele);
          }
        });
        await resourceAllocatedOptions.map((ele: any) => {
          if (ele.value === data.employeeId) {
            setResourceAllocated(ele);
          }
        });
        await getCapacityEngagementByIdApiCall(data.engagementId);
        //await getCapacityAllocationGridDataApiCall(data.engagementId);
        await capacityEngagementApiCall(data.engagementType);
        if (data && Object.keys(data).length > 0 && props.type === "AMC") {
          setMandaysAllocated(data.mandays);
          await getAllocatedMandaysPerMonthEdit(
            data.engagementId,
            moment(data.fromDate).format(moment.HTML5_FMT.DATE),
            moment(data.toDate).format(moment.HTML5_FMT.DATE)
          );
          await getTotalMandaysAllocatedEdit(
            data.employeeId,
            moment(data.fromDate).format(moment.HTML5_FMT.DATE),
            moment(data.toDate).format(moment.HTML5_FMT.DATE),
            data.mandays
          );
        }
        if (data && Object.keys(data).length > 0 && props.type === "T&M") {
          setMandaysAllocated(data.mandays);
          await getAllocatedMandaysPerMonthEdit(
            data.engagementId,
            moment(data.fromDate).format(moment.HTML5_FMT.DATE),
            moment(data.toDate).format(moment.HTML5_FMT.DATE)
          );
          await getTotalMandaysAllocatedEdit(
            data.employeeId,
            moment(data.fromDate).format(moment.HTML5_FMT.DATE),
            moment(data.toDate).format(moment.HTML5_FMT.DATE),
            data.mandays
          );
        }
        if (data && Object.keys(data).length > 0 && props.type === "PROJECT") {
          setMandaysAllocated(data.mandays);
          await getAllocatedMandaysPerMonthEdit(
            data.engagementId,
            moment(data.fromDate).format(moment.HTML5_FMT.DATE),
            moment(data.toDate).format(moment.HTML5_FMT.DATE)
          );
          await getTotalMandaysAllocatedEdit(
            data.employeeId,
            moment(data.fromDate).format(moment.HTML5_FMT.DATE),
            moment(data.toDate).format(moment.HTML5_FMT.DATE),
            data.mandays
          );
        }
      }
      window.scrollTo(0, 0);
    }
  };

  const getResourceLeaves = async (id) => {
    let obj = {
      Id: id, //resource id not engagementId
      FromDate: moment(fromDate).format(moment.HTML5_FMT.DATE),
      ToDate: moment(toDate).format(moment.HTML5_FMT.DATE),
    };

    const { data } = await APICall(getResourcePlannedLeave, "POST", obj);
    if (Object.keys(data).length > 0) {
      setResourceLeave(data.resourceLeave);
    }
  };

  const getAllAvailableMandays = async (id) => {
    let postobj = {
      EmployeeId: id,
      FromDate: moment(fromDate).format(moment.HTML5_FMT.DATE),
      ToDate: moment(toDate).format(moment.HTML5_FMT.DATE),
    };
    const { data } = await APICall(getTotalAvailableMandays, "POST", postobj);
    if (Object.keys(data).length > 0) {
      setTotalAvailableMandays(data[0].resourceDays);
    }
  };

  const getAllocatedResourcePerMonth = async (field, value) => {
    if (typeofEngagement.label === "T&M") {
      let post;
      if (field === "engagement" && fromDate && toDate && value) {
        post = {
          EngagementId: value,
          FromDate: moment(fromDate).format(moment.HTML5_FMT.DATE),
          ToDate: moment(toDate).format(moment.HTML5_FMT.DATE),
        };
      } else if (
        field === "fromDate" &&
        engagement &&
        engagement.engagementId &&
        engagement.engagementId !== 0 &&
        toDate &&
        value
      ) {
        post = {
          EngagementId: engagement.engagementId,
          FromDate: moment(new Date(value)).format(moment.HTML5_FMT.DATE),
          ToDate: moment(toDate).format(moment.HTML5_FMT.DATE),
        };
      } else if (
        field === "toDate" &&
        engagement &&
        engagement.engagementId &&
        engagement.engagementId !== 0 &&
        fromDate &&
        value
      ) {
        post = {
          EngagementId: engagement.engagementId,
          FromDate: moment(fromDate).format(moment.HTML5_FMT.DATE),
          ToDate: moment(new Date(value)).format(moment.HTML5_FMT.DATE),
        };
      } else if (
        field === "" &&
        engagement &&
        engagement.engagementId &&
        engagement.engagementId !== 0 &&
        fromDate &&
        toDate
      ) {
        post = {
          EngagementId: engagement.engagementId,
          FromDate: moment(fromDate).format(moment.HTML5_FMT.DATE),
          ToDate: moment(toDate).format(moment.HTML5_FMT.DATE),
        };
      }
      const { data } = await APICall(
        getAllocatedResourcePerMonthApiCall,
        "POST",
        post
      );
      if (data) {
        setAllocatedResourcesPerMonth(data.allocatedResourcePerMonth);
      }
    }
  };

  const getAllocatedMandaysPerMonth = async (field, value) => {
    if (typeofEngagement.label === "AMC") {
      let post;
      if (field === "engagement" && fromDate && toDate && value) {
        post = {
          EngagementId: value,
          FromDate: moment(fromDate).format(moment.HTML5_FMT.DATE),
          ToDate: moment(toDate).format(moment.HTML5_FMT.DATE),
        };
      } else if (
        field === "fromDate" &&
        engagement &&
        engagement.engagementId &&
        engagement.engagementId !== 0 &&
        toDate &&
        value
      ) {
        post = {
          EngagementId: engagement.engagementId,
          FromDate: moment(new Date(value)).format(moment.HTML5_FMT.DATE),
          ToDate: moment(toDate).format(moment.HTML5_FMT.DATE),
        };
      } else if (
        field === "toDate" &&
        engagement &&
        engagement.engagementId &&
        engagement.engagementId !== 0 &&
        fromDate &&
        value
      ) {
        post = {
          EngagementId: engagement.engagementId,
          FromDate: moment(fromDate).format(moment.HTML5_FMT.DATE),
          ToDate: moment(new Date(value)).format(moment.HTML5_FMT.DATE),
        };
      } else if (
        field === "" &&
        engagement &&
        engagement.engagementId &&
        engagement.engagementId !== 0 &&
        fromDate &&
        toDate
      ) {
        post = {
          EngagementId: engagement.engagementId,
          FromDate: moment(fromDate).format(moment.HTML5_FMT.DATE),
          ToDate: moment(toDate).format(moment.HTML5_FMT.DATE),
        };
      }
      const { data } = await APICall(
        getAllocatedMandaysPerMonthApiCall,
        "POST",
        post
      );
      if (data && data.allocatedMandaysPerMonth) {
        setAllocatedMandaysPerMonth(data.allocatedMandaysPerMonth || 0);
      }
    }
  };

  const deletedaAllocatedResource = async () => {
    if (capacityAllocationId !== 0) {
      let post = {
        id: capacityAllocationId,
      };
      const data = await APICall(deleteResourceAllocated, "POST", post);
      if (Object.keys(engagement).length > 0) {
        await getCapacityAllocationGridDataApiCall(
          "engagement",
          engagement.engagementId
        );
        setResourceAllocated({});
        setTotalMandaysAllocated("");
      }
    }
    handleClose();
  };

  const getTotalAllocatedMandays = async (field, value) => {
    if (
      typeofEngagement.label === "AMC" ||
      typeofEngagement.label === "PROJECT" ||
      typeofEngagement.label === "PRODUCT" ||
      typeofEngagement.label === "INTERNAL" ||
      typeofEngagement.label === "T&M"
    ) {
      let post;
      if (field === "resourceAllocated" && fromDate && toDate && value) {
        post = {
          EmployeeId: value,
          FromDate: moment(fromDate).format(moment.HTML5_FMT.DATE),
          ToDate: moment(toDate).format(moment.HTML5_FMT.DATE),
        };
      } else if (
        field === "fromDate" &&
        resourceAllocated &&
        resourceAllocated.value &&
        resourceAllocated.value !== 0 &&
        toDate &&
        value
      ) {
        post = {
          EmployeeId: resourceAllocated.value,
          FromDate: moment(new Date(value)).format(moment.HTML5_FMT.DATE),
          ToDate: moment(toDate).format(moment.HTML5_FMT.DATE),
        };
      } else if (
        field === "toDate" &&
        resourceAllocated &&
        resourceAllocated.value &&
        resourceAllocated.value !== 0 &&
        fromDate &&
        value
      ) {
        post = {
          EmployeeId: resourceAllocated.value,
          FromDate: moment(fromDate).format(moment.HTML5_FMT.DATE),
          ToDate: moment(new Date(value)).format(moment.HTML5_FMT.DATE),
        };
      } else if (
        field === "" &&
        resourceAllocated &&
        resourceAllocated.value &&
        resourceAllocated.value !== 0 &&
        fromDate &&
        toDate
      ) {
        post = {
          EmployeeId: resourceAllocated.value,
          FromDate: moment(fromDate).format(moment.HTML5_FMT.DATE),
          ToDate: moment(toDate).format(moment.HTML5_FMT.DATE),
        };
      }
      const { data } = await APICall(
        getTotalAllocatedMandaysApiCall,
        "POST",
        post
      );
      if (data && data.totalAllocatedMandays) {
        setTotalMandaysAllocated(data.totalAllocatedMandays);
      }
    }
  };

  const getTotalResourceAllocation = async (field, value) => {
    if (typeofEngagement.label === "T&M") {
      let post;
      if (field === "resourceAllocated" && fromDate && toDate && value) {
        post = {
          EmployeeId: value,
          FromDate: moment(fromDate).format(moment.HTML5_FMT.DATE),
          ToDate: moment(toDate).format(moment.HTML5_FMT.DATE),
        };
      } else if (
        field === "fromDate" &&
        resourceAllocated &&
        resourceAllocated.value &&
        resourceAllocated.value !== 0 &&
        toDate &&
        value
      ) {
        post = {
          EmployeeId: resourceAllocated.value,
          FromDate: moment(new Date(value)).format(moment.HTML5_FMT.DATE),
          ToDate: moment(toDate).format(moment.HTML5_FMT.DATE),
        };
      } else if (
        field === "toDate" &&
        resourceAllocated &&
        resourceAllocated.value &&
        resourceAllocated.value !== 0 &&
        fromDate &&
        value
      ) {
        post = {
          EmployeeId: resourceAllocated.value,
          FromDate: moment(fromDate).format(moment.HTML5_FMT.DATE),
          ToDate: moment(new Date(value)).format(moment.HTML5_FMT.DATE),
        };
      } else if (
        field === "" &&
        resourceAllocated &&
        resourceAllocated.value &&
        resourceAllocated.value !== 0 &&
        fromDate &&
        toDate
      ) {
        post = {
          EmployeeId: resourceAllocated.value,
          FromDate: moment(fromDate).format(moment.HTML5_FMT.DATE),
          ToDate: moment(toDate).format(moment.HTML5_FMT.DATE),
        };
      }
      const { data } = await APICall(
        getTotalResourceAllocationApiCall,
        "POST",
        post
      );
      if (data && data.totalResourceAllocation) {
        setTotalResourceAllocation(data.totalResourceAllocation);
      }
    }
  };

  const options = {
    selectableRows: "none",
    count: count,
    start: start,
    page: page,
    pageSize: pageSize, //passing page size for pagination   --sangam
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,

    onChangeRowsPerPage: (num) => { },
    onSearchChange: (searchText) => {
      //sangam
      if (searchText !== null) {
        setSearchText(searchText);
      } else {
        setSearchText("");
      }
    },

    //sangam
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        await setSortDirection(sortDirection);
        await setSortColumn(sortColumn);
      }
      if (sortDirection === "desc") {
        await setSortDirection(sortDirection);
        await setSortColumn(sortColumn);
      }
    },

    onChangePage: async (page) => {
      setPage(page);
      setStart(page * pageSize); //sangam
    },
  };

  // const engagementLeadsManagersApiCall = async () => {
  //   let postObject = {
  //     "searchFor": "engagementLeadsManagers",
  //     "searchValue": 1
  //   }
  //   const { data } = await APICall(GetDropDownList, "POST", postObject);
  //   if (data != undefined || data != null) {
  //     let engagementLeadsManagersArray = [];
  //     await data.map((engagementLeadsManager: any) => {
  //       let tempObj = {
  //         value: engagementLeadsManager.id,
  //         label: engagementLeadsManager.name
  //       }
  //       engagementLeadsManagersArray.push(tempObj);
  //     })
  //     setEngagementLeadsManagersOptions(engagementLeadsManagersArray);
  //   }
  // }

  const resourceApiCall = async () => {
    let postObject = {
      searchFor: "employee",
      searchValue: 1,
    };
    const { data } = await APICall(GetDropDownList, "POST", postObject);

    if (data != undefined || data != null) {
      let employeeArray = [];
      await data.map((employee: any) => {
        let tempObj = {
          value: employee.id,
          label: employee.name,
          workPolicyId: employee.workPolicyId,
        };
        employeeArray.push(tempObj);
      });
      setResourceAllocatedOptions(employeeArray);
    }
  };

  const capacityEngagementApiCall = async (type: any) => {
    let postObject = {
      searchFor: "capacityEngagement",
      searchValue: type,
    };
    const { data } = await APICall(GetDropDownList, "POST", postObject);

    if (data) {
      let engagementArray = [];
      if (type > 0) {
        await data.map((engagement: any) => {
          let tempObj = {
            phasevalue: null,
            label: `${engagement.engagement}`,
            value: uuid(),
            engagementId: engagement.id,
          };
          engagementArray.push(tempObj);
        });
        engagementArray.sort((a, b) => a.label.localeCompare(b.label));
        setEngagementOptions(engagementArray);
      }
      // else {
      //   engagementArray = [];
      //   await data.map((engagement) => {
      //     let tempObj;
      //     if (engagement.phase != null) {
      //       tempObj = {
      //         phasevalue: engagement.phaseId,
      //         label: `${engagement.engagement}-${engagement.phase}`,
      //         value: uuid(),
      //         engagementId: engagement.engagementId,
      //         // empId: engagement.employeeId,
      //         // engagementType: engagement.engagementType,
      //       };
      //     } else if (engagement.application != null) {
      //       tempObj = {
      //         applicationValue: engagement.applicationId,
      //         label: ` ${engagement.engagement}-${engagement.application}`,
      //         value: uuid(),
      //         engagementId: engagement.engagementId,
      //         // empId: engagement.employeeId,
      //         // engagementType: engagement.engagementType,
      //       };
      //     } else {
      //       tempObj = {
      //         phasevalue: engagement.phaseId,
      //         label: `${engagement.engagement}`,
      //         value: uuid(),
      //         engagementId: engagement.engagementId,
      //         // empId: engagement.employeeId,
      //         // engagementType: engagement.engagementType,
      //       };
      //     }
      //     engagementArray.push(tempObj);
      //   });
      //   setEngagementOptions(engagementArray);
      // }
    }
  };

  const getEngagementTypeFuncCall = (type: any) => {
    if (type !== "PROJECT") {
      enagagementTypeOptions.map(async (ele: any) => {
        if (ele.label == type) {
          setTypeofEngagement(ele);
          await capacityEngagementApiCall(ele.value);
          // await engagementLeadsManagersApiCall()
        }
      });
      setEnagagementTypeOptionsArr(enagagementTypeOptions);
    } else {
      var newArray = enagagementTypeOptions.filter((el: any) => {
        return (
          el.label === "PROJECT" ||
          el.label === "PRODUCT" ||
          el.label === "INTERNAL"
        );
      });
      setEnagagementTypeOptionsArr(newArray);
    }
  };

  const onLoadFunCall = async () => {
    await getEngagementTypeFuncCall(props.type);
    // await capacityEngagementApiCall()
    // setPlannedHours(0)
    await resourceApiCall();
  };

  const CreatePlannedHours = async () => {
    //debugger;
    let requestObj = {
      WorkPolicyId: resourceAllocated.workPolicyId,
      IsActive: true,
    };

    const { data } = await APICall(
      getWorkPolicyWorkdayList,
      "POST",
      requestObj
    );
    let plannedhours = 0;
    const d = new Date();
    if (mandaysAllocated > 0) {
      if (data[5] == null) {
        plannedhours = mandaysAllocated * 8.5;
      } else {
        plannedhours = mandaysAllocated * 8;
      }
    }

    let postobj: any = {};
    postobj = {
      AssignedTo: resourceAllocated.value,
      EngagementId: engagement.engagementId,
      PlannedStartDate: moment(fromDate).format(moment.HTML5_FMT.DATE),
      PlannedEndDate: moment(toDate).format(moment.HTML5_FMT.DATE),
      AutoTimesheet: autoTimeSheet,
      TaskUid: uuid(),
      TaskTitle: engagement.label + monthNames[d.getMonth()],
      TaskDescription: engagement.label + monthNames[d.getMonth()],
    };
    const data1 = await APICall(getTaskID, "POST", postobj);
    // console.log('data1==>',data1)

    if (plannedhours != 0) {
      if (autoTimeSheet === true) {
        let requirementId;
        let reqObj = {
          EngagementId: engagement.engagementId,
        };
        const { data } = await APICall(getRequirements, "POST", reqObj);
        //  console.log('data requirement ==>',data)
        if (data != null && data != undefined) {
          requirementId = data.id;
        }
        //console.log('requirement data=>',data);
        let requestObject = {};

        if (data1.data == 0 || data1.data == null) {
          let formdata = new FormData();

          requestObject = {
            TaskUid: uuid(),
            EngagementId: engagement.engagementId,
            PhaseId: parseInt(engagement.phasevalue),
            ApplicationId: parseInt(engagement.applicationValue),
            RequirementId: requirementId ? requirementId : null, //null,
            TaskTitle: engagement.label + monthNames[d.getMonth()],
            TaskDescription: engagement.label + monthNames[d.getMonth()],
            AssignedTo: resourceAllocated.value,
            PlannedStartDate: moment(fromDate).format(moment.HTML5_FMT.DATE),
            PlannedEndDate: moment(toDate).format(moment.HTML5_FMT.DATE),
            HoursAssigned: plannedhours,
            HoursSpent: 0,
            TaskStatus: TaskStatus.NotStarted,
            IsChargeable: isChargable,
            CreatedBy: Number(context.EmployeeId),
            CreatedDate: moment(new Date()).format(moment.HTML5_FMT.DATE),
            AutoTimesheet: autoTimeSheet,
            IsUnplanned: props.type === "T&M" ? true : false,
          };

          formdata.append("TaskUid", uuid());
          formdata.append("EngagementId", engagement.engagementId);
          if (engagement.phasevalue === undefined || engagement.phasevalue === null || engagement.phasevalue === "") {
            formdata.append("PhaseId", "");  // Send "null" as a string so the API can interpret it correctly
        } else {
            formdata.append("PhaseId", parseInt(engagement.phasevalue, 10).toString());
        }
        
        if (engagement.applicationValue === undefined || engagement.applicationValue === null || engagement.applicationValue === "") {
            formdata.append("ApplicationId", "");  // Send "null" as a string
        } else {
            formdata.append("ApplicationId", parseInt(engagement.applicationValue, 10).toString());
        }
          formdata.append("RequirementId", requirementId ? requirementId : "");
          formdata.append("TaskTitle", engagement.label + monthNames[d.getMonth()]);
          formdata.append("TaskDescription", engagement.label + monthNames[d.getMonth()]);
          formdata.append("AssignedTo", resourceAllocated.value);
          formdata.append("PlannedStartDate", moment(fromDate).format(moment.HTML5_FMT.DATE));
          formdata.append("PlannedEndDate", moment(toDate).format(moment.HTML5_FMT.DATE));
          formdata.append("HoursAssigned", plannedhours.toString());
          formdata.append("HoursSpent", String(0));
          formdata.append("TaskStatus", TaskStatus.NotStarted.toString());
          formdata.append("IsChargeable", isChargable);
          formdata.append("CreatedBy", Number(context.EmployeeId).toString());
          formdata.append("CreatedDate", moment(new Date()).format(moment.HTML5_FMT.DATE));
          formdata.append("AutoTimesheet", autoTimeSheet.toString());
          formdata.append("IsUnplanned", (props.type === "T&M" ? true : false).toString());


          // Object.keys(requestObject).forEach((key) => {
          //   formdata.append(key, requestObject[key]);
          // });

          // console.log(' if task obj=>>',requestObject,'formdata=>',formdata)

          const data = await APICalls(InsertUpdateTask, "POST", formdata);
        } else {
          //  const obj = { Id : submitId, mandays : mandaysAllocated }
          //   const data2 = await APICall (getCAID , "POST", obj)
          let formdata1 = new FormData();

          requestObject = {
            Id: data1.data,
            TaskUid: uuid(),
            TaskTitle: engagement.label + monthNames[d.getMonth()],
            HoursAssigned: plannedhours,
            TaskDescription: engagement.label + monthNames[d.getMonth()],
            AssignedTo: resourceAllocated.value,
            EngagementId: engagement.engagementId,
            TaskStatus: TaskStatus.NotStarted,
            IsChargeable: isChargable,
            AutoTimesheet: autoTimeSheet,
            PlannedStartDate: moment(fromDate).format(moment.HTML5_FMT.DATE),
            PlannedEndDate: moment(toDate).format(moment.HTML5_FMT.DATE),
            //createdDate: new Date(),
            ModifiedBy: Number(context.EmployeeId),
            ModifiedDate: moment(new Date()).format(moment.HTML5_FMT.DATE),
            IsUnplanned: props.type === "T&M" ? true : false,
            PhaseId: parseInt(engagement.phasevalue),
            ApplicationId: parseInt(engagement.applicationValue),
            RequirementId: requirementId ? requirementId : null, //null,
            IsActive : isActive,
          };

          formdata1.append("Id", data1.data);
          formdata1.append("TaskUid", uuid());
          formdata1.append("EngagementId", engagement.engagementId);
          if (engagement.phasevalue === undefined || engagement.phasevalue === null || engagement.phasevalue === "") {
            formdata1.append("PhaseId", "");  // Send "null" as a string so the API can interpret it correctly
        } else {
            formdata1.append("PhaseId", parseInt(engagement.phasevalue, 10).toString());
        }
        
        if (engagement.applicationValue === undefined || engagement.applicationValue === null || engagement.applicationValue === "") {
            formdata1.append("ApplicationId", "");  // Send "null" as a string
        } else {
            formdata1.append("ApplicationId", parseInt(engagement.applicationValue, 10).toString());
        }
          formdata1.append("RequirementId", requirementId ? requirementId : "");
          // formdata1.append("PhaseId", parseInt(engagement.phasevalue ? engagement.phasevalue : "").toString());
          // formdata1.append("ApplicationId", parseInt(engagement.applicationValue ? engagement.applicationValue : "").toString());
          // formdata1.append("RequirementId", requirementId ? requirementId : "");
          formdata1.append("TaskTitle", engagement.label + monthNames[d.getMonth()]);
          formdata1.append("TaskDescription", engagement.label + monthNames[d.getMonth()]);
          formdata1.append("AssignedTo", resourceAllocated.value);
          formdata1.append("PlannedStartDate", moment(fromDate).format(moment.HTML5_FMT.DATE));
          formdata1.append("PlannedEndDate", moment(toDate).format(moment.HTML5_FMT.DATE));
          formdata1.append("HoursAssigned", plannedhours.toString());
          //formdata1.append("HoursSpent", String(0));
          formdata1.append("TaskStatus", TaskStatus.NotStarted.toString());
          formdata1.append("IsChargeable", isChargable);
          formdata1.append("ModifiedBy", Number(context.EmployeeId).toString());
          formdata1.append("ModifiedDate", moment(new Date()).format(moment.HTML5_FMT.DATE));
          formdata1.append("AutoTimesheet", autoTimeSheet.toString());
          formdata1.append("IsUnplanned", (props.type === "T&M" ? true : false).toString());
          formdata1.append("IsActive", isActive? "true": "false");

          // console.log(' else task obj=>>',requestObject)
          const datainsert = await APICalls(
            InsertUpdateTask,
            "POST",
            formdata1
          );
        }
      }
    }
    //else {
    //   notify(1, "Planned Hourse cannot be zero.");
    // }
  };

  // const CreateTask = async () => {
  //   debugger;
  //   await CreatePlannedHours();

  //   if (autoTimeSheet === true) {
  //     let requestObject = {};
  //     requestObject = {
  //       TaskUid: uuid(),
  //       EngagementId: engagement.engagementId,
  //       PhaseId: parseInt(engagement.phasevalue),
  //       ApplicationId: parseInt(engagement.applicationValue),
  //       RequirementId: null,
  //       TaskTitle: "title",
  //       TaskDescription: "descriptiom",
  //       AssignedTo: resourceAllocated.value,
  //       PlannedStartDate: moment(fromDate).format(moment.HTML5_FMT.DATE),
  //       PlannedEndDate: moment(toDate).format(moment.HTML5_FMT.DATE),
  //       HoursAssigned:
  //         plannedHours !== 0
  //           ? plannedHours
  //           : notify(1, "PlannedHours Should not be 0"),

  //       HoursSpent: 0,
  //       TaskStatus: TaskStatus.NotStarted,
  //       IsChargeable: isChargable,
  //       CreatedBy: Number(context.EmployeeId),
  //       CreatedDate: moment(new Date()).format(moment.HTML5_FMT.DATE),
  //     };

  //     if (plannedHours > 0) {
  //       const data = await APICall(InsertUpdateTask, "POST", requestObject);
  //     } else {
  //       notify(1, "Planned Hours Should not be null or 0 ");
  //     }
  //   }
  // };
  useEffect(() => {
    if (props && props.type && props.type !== "") {
      onLoadFunCall();
    }
    //Added Start and count
  }, [props]);

  useEffect(() => {
    //  for pagination sangam

    (async () => {
      await getCapacityAllocationGridDataApiCallAfterSubmit(
        engagement.engagementId,
        firstDay,
        lastDay
      );

      if (engagement.engagementId == undefined && fromDate && toDate) {
        let post = {
          EngagementId: 0,
          FromDate: moment(fromDate).format(moment.HTML5_FMT.DATE),
          ToDate: moment(toDate).format(moment.HTML5_FMT.DATE),
          //passing start , pageSize ,sortColumn,sortOrder --sangam
          start: start,
          pageSize: pageSize,
          sortColumn: sortColumn,
          sortDirection: sortDirection,
        };

        const { data } = await APICall(
          getCapacityAllocationGridData,
          "POST",
          post
        );

        if (data.length) {
          await setCapacityAllocationGridData(data);
          await setCount(data[0].totalCount && data[0].totalCount); // sangam
        } else {
          //sangam
          setStart(0);
          setCount(0);
          setPage(0);
          await setCapacityAllocationGridData([]);
        }
      }
    })();
  }, [start]);

  //sangam
  useEffect(() => {
    (async () => {
      getCapacityAllocationGridDataApiCall("", "");
    })();
  }, [date]);

  //Sangam for sorting
  useEffect(() => {
    // if (sortColumn == "employeeName") {
    //   if (sortDirection == "asc") {
    //     const sortedData = [...capacityAllocationGridData].sort((a, b) =>
    //       a.employeeName.localeCompare(b.employeeName)
    //     );

    //     setCapacityAllocationGridData(sortedData);
    //   }
    //   if (sortDirection == "desc") {
    //     const sortedData = [...capacityAllocationGridData].sort((a, b) =>
    //       b.employeeName.localeCompare(a.employeeName)
    //     );
    //     setCapacityAllocationGridData(sortedData);
    //   }
    // }
    (async () => {
      getCapacityAllocationGridDataApiCall("", "");
    })();
  }, [sortColumn, sortDirection]);

  // const style = {
  //   position: "absolute" as "absolute",
  //   top: "50%",
  //   left: "50%",
  //   transform: "translate(-50%, -50%)",
  //   width: 360,
  //   bgcolor: "background.paper",
  //   boxShadow: 24,
  //   p: 4,
  // };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <h4 className="page_title">
              Capacity Allocation -{" "}
              {props.type === "PROJECT"
                ? "Project / Product / Internal"
                : typeofEngagement.label}
            </h4>
          </div>
        </div>
      </div>

      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Type of Engagement <sup>*</sup>
              </label>
              <SelectForm
                key={1}
                options={enagagementTypeOptionsArr}
                placeholder="Select"
                isDisabled={props.type !== "PROJECT"}
                value={typeofEngagement}
                onChange={(event) => selectOnChange(event, "typeofEngagement")}
                isMulti={false}
                noIndicator={false}
                noSeparator={false}
              />
              <span style={{ color: "red" }}>
                {formError["typeofEngagement_isEmpty"]}
              </span>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              {/* {props.type == "T&M" ? (
                    <>
                      <label>
                        Engagement<sup>*</sup>
                      </label>
                    </>
                  ) : (
                    <>
                      <label>
                        Engagement/Application/Phase<sup>*</sup>
                      </label>
                    </>
                  )} */}
              <label>
                Engagement <sup>*</sup>
              </label>
              <SelectForm
                options={engagementOptions}
                placeholder="Select"
                isDisabled={false}
                value={engagement}
                onChange={(event) => selectOnChange(event, "engagement")}
                isMulti={false}
                noIndicator={false}
                noSeparator={false}
              />
            </div>
            <span style={{ color: "red" }}>
              {formError["engagement_isEmpty"]}
            </span>
          </div>
          {typeofEngagement.label === "T&M" ? (
            <>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>PO Resources / month</label>
                  <InputForm
                    placeholder={"PO Resources / month"}
                    isDisabled={true}
                    textArea={false}
                    value={poResourcesPerMonth}
                    onChange={(e) => handleTextEvent(e, "poResourcesPerMonth")}
                    className="numRight"
                    type="number"
                    onKeyPress={(event) => {
                      if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                  <span style={{ color: "red" }}>
                    {formError["poResourcesPerMonth_isEmpty"]}
                  </span>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>Budget Resources / month</label>
                  <InputForm
                    placeholder={""}
                    isDisabled={true}
                    textArea={false}
                    value={budgetResourcesPerMonth}
                    onChange={(e) =>
                      handleTextEvent(e, "budgetResourcesPerMonth")
                    }
                    className="numRight"
                    type="number"
                    onKeyPress={(event) => {
                      if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                  <span style={{ color: "red" }}>
                    {formError["budgetResourcesPerMonth_isEmpty"]}
                  </span>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>Allocated Resources / month</label>
                  <InputForm
                    placeholder={""}
                    isDisabled={true}
                    textArea={false}
                    value={allocatedResourcesPerMonth}
                    onChange={(e) =>
                      handleTextEvent(e, "allocatedResourcesPerMonth")
                    }
                    className="numRight"
                    type="number"
                    onKeyPress={(event) => {
                      if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                  <span style={{ color: "red" }}>
                    {formError["allocatedResourcesPerMonth_isEmpty"]}
                  </span>
                </div>
              </div>
            </>
          ) : typeofEngagement.label === "AMC" ? (
            <>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>PO Mandays / month</label>
                  <InputForm
                    placeholder={""}
                    isDisabled={true}
                    textArea={false}
                    value={poMandaysPerMonth}
                    onChange={(e) => handleTextEvent(e, "poMandaysPerMonth")}
                    className="numRight"
                    type="number"
                    onKeyPress={(event) => {
                      if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                  <span style={{ color: "red" }}>
                    {formError["poMandaysPerMonth_isEmpty"]}
                  </span>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>Budget Mandays / month</label>
                  <InputForm
                    placeholder={""}
                    isDisabled={true}
                    textArea={false}
                    value={budgetMandaysPerMonth}
                    onChange={(e) =>
                      handleTextEvent(e, "budgetMandaysPerMonth")
                    }
                    className="numRight"
                    type="number"
                    onKeyPress={(event) => {
                      if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                  <span style={{ color: "red" }}>
                    {formError["budgetMandaysPerMonth_isEmpty"]}
                  </span>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>Allocated Mandays / month</label>
                  <InputForm
                    placeholder={""}
                    isDisabled={true}
                    textArea={false}
                    value={allocatedMandaysPerMonth}
                    onChange={(e) =>
                      handleTextEvent(e, "allocatedMandaysPerMonth")
                    }
                    className="numRight"
                    type="number"
                    onKeyPress={(event) => {
                      if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                  <span style={{ color: "red" }}>
                    {formError["allocatedMandaysPerMonth_isEmpty"]}
                  </span>
                </div>
              </div>
            </>
          ) : typeofEngagement.label === "PROJECT" ||
            typeofEngagement.label === "PRODUCT" ||
            typeofEngagement.label === "INTERNAL" ? (
            <>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>PO Mandays</label>
                  <InputForm
                    placeholder={""}
                    isDisabled={true}
                    textArea={false}
                    value={poMandays}
                    onChange={(e) => handleTextEvent(e, "poMandays")}
                    className="numRight"
                    type="number"
                    onKeyPress={(event) => {
                      if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>Budget Mandays</label>
                  <InputForm
                    placeholder={""}
                    isDisabled={true}
                    textArea={false}
                    value={budgetMandays}
                    onChange={(e) => handleTextEvent(e, "budgetMandays")}
                    className="numRight"
                    type="number"
                    onKeyPress={(event) => {
                      if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>Spent Mandays</label>
                  <InputForm
                    placeholder={""}
                    isDisabled={true}
                    textArea={false}
                    value={spentMandays}
                    onChange={(e) => handleTextEvent(e, "spentMandays")}
                    className="numRight"
                    type="number"
                    onKeyPress={(event) => {
                      if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>Balance Mandays</label>
                  <InputForm
                    placeholder={""}
                    isDisabled={true}
                    textArea={false}
                    value={balanceMandays}
                    onChange={(e) => handleTextEvent(e, "balancedMandays")}
                    className="numRight"
                    type="number"
                    onKeyPress={(event) => {
                      if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </div>
              </div>

              {/* <div className="row">
                    <div className="col-lg-4 col-md-4 col-sm-6">
                      <div className="form-group">
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DatePicker
                            label="PO Completion Date"
                            value={poCompletionDate}
                            onChange={(e) =>
                              handleTextEvent(e, "poCompletionDate")
                            }
                            inputFormat="dd/MM/yyyy"
                            renderInput={(params) => (
                              <TextField size="small" {...params} />
                            )}
                            disabled={true}
                          />
                        </LocalizationProvider>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-6">
                      <div className="form-group">
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DatePicker
                            label="Planned Completion Date"
                            value={plannedCompletionDate}
                            onChange={(e) =>
                              handleTextEvent(e, "plannedCompletionDate")
                            }
                            inputFormat="dd/MM/yyyy"
                            renderInput={(params) => (
                              <TextField size="small" {...params} />
                            )}
                            disabled={true}
                          />
                        </LocalizationProvider>
                      </div>
                    </div>
                  </div> */}
            </>
          ) : null}
          {/* <label>Engagement Lead(s) / Manager(s)</label>
              <SelectForm
                options={engagementLeadsManagersOptions}
                placeholder="Select"
                isDisabled={false}
                value={engagementLeadsManagers}
                onChange={(event) =>
                  selectOnChange(event, "engagementLeadsManagers")
                }
                isMulti={false}
                noIndicator={false}
                noSeparator={false} />
              <span style={{ color: "red" }}>
                {formError["engagementLeadsManagers_isEmpty"]}
              </span> */}

          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>Select Date</label>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  views={["year", "month"]}
                  label="Year and Month"
                  value={date}
                  onChange={(e) => {
                    selectOnChange(e, "Year&Month");
                  }}
                  renderInput={(params) => (
                    <TextField size="small" {...params} />
                  )}
                />
              </LocalizationProvider>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                From Date <sup>*</sup>
              </label>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="From date"
                  value={fromDate}
                  onChange={(e) => {
                    handleTextEvent(e, "fromDate");
                  }}
                  disabled={true}
                  inputFormat="dd/MM/yyyy"
                  renderInput={(params) => (
                    <TextField size="small" required {...params} />
                  )}
                />
              </LocalizationProvider>
              <span style={{ color: "red" }}>
                {formError["fromDate_isEmpty"]}
              </span>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label className="d-block">
                To Date <sup>*</sup>
              </label>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="To date"
                  disabled={true}
                  value={toDate}
                  onChange={(e) => handleTextEvent(e, "toDate")}
                  inputFormat="dd/MM/yyyy"
                  minDate={fromDate}
                  renderInput={(params) => (
                    <TextField required size="small" {...params} />
                  )}
                />
              </LocalizationProvider>
              <span style={{ color: "red" }}>
                {formError["toDate_isEmpty"]}
              </span>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Resource Allocated <sup>*</sup>
              </label>
              <SelectForm
                options={resourceAllocatedOptions}
                placeholder="Select"
                isDisabled={false}
                value={resourceAllocated}
                onChange={(event) => selectOnChange(event, "resourceAllocated")}
                isMulti={false}
                noIndicator={false}
                noSeparator={false}
              />
              <span style={{ color: "red" }}>
                {formError["resourceAllocated_isEmpty"]}
              </span>
            </div>
          </div>
          {/* <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>Resource planned leaves</label>
                    <InputForm
                      placeholder={""}
                      isDisabled={true}
                      textArea={false}
                      value={resourceLeave}
                      onChange={(e) =>
                        handleTextEvent(e, "allocatedMandaysPerMonth")
                      }
                      className="numRight"
                      type="number"
                    />
                  </div>
                </div> */}
          {/* <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>Total Available Mandays</label>
                    <InputForm
                      placeholder={""}
                      isDisabled={true}
                      textArea={false}
                      value={totalAvailableMandays}
                      onChange={(e) =>
                        handleTextEvent(e, "totalAvailableMandays")
                      }
                      className="numRight"
                      type="number"
                    />
                  </div>
                </div> */}
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Mandays Allocated <sup>*</sup>
              </label>
              <InputForm
                placeholder={""}
                isDisabled={false}
                textArea={false}
                value={mandaysAllocated}
                onChange={(e) => handleTextEvent(e, "mandaysAllocated")}
                className="numRight"
                type="number"
                onKeyPress={(event) => {
                  if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
              />
              <span style={{ color: "red" }}>
                {formError["mandaysAllocated_isEmpty"]}
              </span>
            </div>
          </div>
          {/* <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>Resource Working Days</label>
                    <InputForm
                      placeholder={""}
                      isDisabled={true}
                      textArea={false}
                      value={resourceWorkingDays}
                      onChange={(e) => handleTextEvent(e, "resourceWorking")}
                      className="numRight"
                      type="number"
                    />
                  </div>
                </div> */}
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label htmlFor="isEngagementLead">Is Engagement Lead</label>
              <div>
                <input
                  id="isEngagementLead"
                  type="checkbox"
                  onChange={(e) => setIsEngagementLead(e.target.checked)}
                  name="isEngagementLead"
                  checked={isEngagementLead}
                />
                <span style={{ color: "red" }}>
                  {formError["isEngagementLead_isEmpty"]}
                </span>
              </div>
            </div>
          </div>
          {typeofEngagement.label === "T&M" ? (
            // <>
            //   <div className="col-lg-3 col-md-4 col-sm-6">
            //     <div className="form-group">
            //       <label>
            //         Fraction Allocated<sup>*</sup>
            //       </label>
            //       <InputForm
            //         placeholder={""}
            //         isDisabled={false}
            //         textArea={false}
            //         value={fractionAllocated}
            //         onChange={(e) =>
            //           handleTextEvent(e, "fractionAllocated")
            //         }
            //         className="numRight"
            //         type="number"
            //         onKeyPress={(event) => {
            //           if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
            //             event.preventDefault();
            //           }
            //         }}
            //       />
            //       <span style={{ color: "red" }}>
            //         {formError["fractionAllocated_isEmpty"]}
            //       </span>
            //     </div>
            //   </div>
            //   <div className="col-lg-3 col-md-4 col-sm-6">
            //     <div className="form-group">
            //       <label>Total Resource Allocation</label>
            //       <InputForm
            //         placeholder={""}
            //         isDisabled={true}
            //         textArea={false}
            //         value={totalResourceAllocation}
            //         onChange={(e) =>
            //           handleTextEvent(e, "totalResourceAllocation")
            //         }
            //         className="numRight"
            //         type="number"
            //         onKeyPress={(event) => {
            //           if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
            //             event.preventDefault();
            //           }
            //         }}
            //       />
            //       <span style={{ color: "red" }}>
            //         {formError["totalResourceAllocation_isEmpty"]}
            //       </span>
            //     </div>
            //   </div>
            // </>
            <>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>Total Available Mandays</label>
                  <InputForm
                    placeholder={""}
                    isDisabled={true}
                    textArea={false}
                    value={totalAvailableMandays}
                    onChange={(e) =>
                      handleTextEvent(e, "totalAvailableMandays")
                    }
                    className="numRight"
                    type="number"
                  />
                </div>
              </div>
              {/* <div className="col-lg-4 col-md-4 col-sm-6">
                      <div className="form-group">
                        <label>
                          Mandays Allocated<sup>*</sup>
                        </label>
                        <InputForm
                          placeholder={""}
                          isDisabled={false}
                          textArea={false}
                          value={mandaysAllocated}
                          onChange={(e) =>
                            handleTextEvent(e, "mandaysAllocated")
                          }
                          className="numRight"
                          type="number"
                          onKeyPress={(event) => {
                            if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                        />
                        <span style={{ color: "red" }}>
                          {formError["mandaysAllocated_isEmpty"]}
                        </span>
                      </div>
                    </div> */}
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>Total Allocated Mandays</label>
                  <InputForm
                    placeholder={""}
                    isDisabled={true}
                    textArea={false}
                    value={totalMandaysAllocated}
                    onChange={(e) =>
                      handleTextEvent(e, "totalMandaysAllocated")
                    }
                    className="numRight"
                    type="number"
                    onKeyPress={(event) => {
                      if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                  <span style={{ color: "red" }}>
                    {formError["totalMandaysAllocated_isEmpty"]}
                  </span>
                </div>
              </div>
            </>
          ) : typeofEngagement.label === "AMC" ||
            typeofEngagement.label === "PROJECT" ||
            typeofEngagement.label === "PRODUCT" ||
            typeofEngagement.label === "INTERNAL" ? (
            <>
              {/* <div className="col-lg-4 col-md-4 col-sm-6">
                      <div className="form-group">
                        <label>
                          Mandays Allocated<sup>*</sup>
                        </label>
                        <InputForm
                          placeholder={""}
                          isDisabled={false}
                          textArea={false}
                          value={mandaysAllocated}
                          onChange={(e) =>
                            handleTextEvent(e, "mandaysAllocated")
                          }
                          className="numRight"
                          type="number"
                          onKeyPress={(event) => {
                            if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                        />
                        <span style={{ color: "red" }}>
                          {formError["mandaysAllocated_isEmpty"]}
                        </span>
                      </div>
                    </div> */}
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>Total Available Mandays</label>
                  <InputForm
                    placeholder={""}
                    isDisabled={true}
                    textArea={false}
                    value={totalAvailableMandays}
                    onChange={(e) =>
                      handleTextEvent(e, "totalAvailableMandays")
                    }
                    className="numRight"
                    type="number"
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>Total Allocated Mandays</label>
                  <InputForm
                    placeholder={""}
                    isDisabled={true}
                    textArea={false}
                    value={totalMandaysAllocated}
                    onChange={(e) =>
                      handleTextEvent(e, "totalMandaysAllocated")
                    }
                    className="numRight"
                    type="number"
                    onKeyPress={(event) => {
                      if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                  <span style={{ color: "red" }}>
                    {formError["totalMandaysAllocated_isEmpty"]}
                  </span>
                </div>
              </div>
            </>
          ) : null}

          {typeofEngagement.label === "T&M" ? (
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group">
                <label htmlFor="AutoTimesheet">AutoTimesheet</label>
                <div>
                  <input
                    id="AutoTimeSheet"
                    type="checkbox"
                    onChange={(e) => setAutoTimeSheet(e.target.checked)}
                    name="AutoTimeSheet"
                    checked={autoTimeSheet}
                  />
                </div>
                {/* <span style={{ color: "red" }}>
                      {formError["isEngagementLead_isEmpty"]}
                    </span> */}
              </div>
            </div>
          ) : null}
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div className="d-flex justify-content-end gap-2">
              {/* <button
                    onClick={() => {
                      {
                        navigate(-1);
                      }
                    }}
                    className="btn btn-secondary"
                  >
                    Back
                  </button> */}
              {/* submitFunc('reset') submitFunc('submit') */}
              <button
                onClick={() => submitFunc("reset")}
                className="btn btn-reset"
              >
                Reset
              </button>
              <button
                onClick={() => submitFunc("submit")}
                className="btn btn-submit"
                disabled={disabled}
              >
                Submit
              </button>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12 mt-3">
            {capacityAllocationGridData &&
              capacityAllocationGridData.length >= 0 && (
                <DynamicGrid
                  title={"Capacity Allocation"}
                  options={options}
                  data={capacityAllocationGridData}
                  columns={capacityAllocationGridDataColumns}
                />
              )}
          </div>
        </div>
      </div>

      <Modal
        show={open}
        onHide={handleClose}
        backdrop="static"
        centered
        size="sm"
      >
        <Modal.Body className="text-center delete_body p-4">
          <i className="fa fa-info mb-3"></i>
          <p className="mb-3">
            Are you sure, you want to delete allocated capacity?
          </p>
          <div className="d-flex justify-content-center gap-2">
            <button
              type="button"
              onClick={() => handleClose()}
              className="btn btn-reset"
            >
              No
            </button>
            <button
              type="button"
              className="btn btn-delete"
              onClick={deletedaAllocatedResource}
            >
              Yes
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CapacityAllocation;
